document.addEventListener('DOMContentLoaded', () => {
    initModals()
    validateForm('form-landing-innovative-wood-stoves-designed-for-architecture');
    validateForm('form-newsletter');
});

function getFormOuter(input) {
    return input.closest('.form-outer');
}

function getMessagesList(outer) {
    return outer.querySelector('.form-messages');
}

function clearMessages(outer) {
    const messages = getMessagesList(outer);
    if (messages) {
        messages.innerHTML = '';
    }
}

function addMessage(outer, message) {
    const messages = getMessagesList(outer);
    if (messages) {
        const li = document.createElement('li');
        li.className = 'form-message';
        li.dataset.messageType = 'validation';
        li.textContent = message;
        messages.appendChild(li);
    }
}

function validateField(input, options = {}) {
    const outer = getFormOuter(input);
    const isSelect = input.tagName.toLowerCase() === 'select';
    const isCheckbox = input.type === 'checkbox';
    const dataType = outer.dataset.type;
    const isRequired = outer.hasAttribute('data-empty');
    const silent = options.silent === true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const telRegex = /^\+?[1-9]\d{1,3}[ \-()]*\d{6,}$/;

    let value;
    let isEmpty = false;
    let isInvalid = false;
    let message = '';

    if (isSelect) {
        const selectedOption = input.options[input.selectedIndex];
        const isPlaceholder = selectedOption?.dataset?.isPlaceholder === "true";
        value = input.value.trim();
        isEmpty = isPlaceholder || value === '';
    } else if (isCheckbox && dataType === 'htmlCheckbox') {
        value = input.checked;
        isEmpty = !value;
    } else {
        value = input.value.trim();
        isEmpty = value === '';
    }

    if (input.type === 'email' && !isEmpty) {
        isInvalid = !emailRegex.test(value);
        if (isInvalid) message = 'Enter a valid email address.';
    }

    if (input.type === 'tel' && !isEmpty) {
        isInvalid = !telRegex.test(value);
        if (isInvalid) message = 'Enter a valid phone number.';
    }

    if (isEmpty && isRequired) {
        isInvalid = true;
        message = 'This field is required.';
    }
    
    // Attributs de validation
    outer.setAttribute('data-empty', isEmpty);
    if (outer.dataset.touched) {
        outer.setAttribute('data-invalid', isInvalid);
    } else {
        outer.setAttribute('data-invalid', false);
    }

    // 🔇 Ne pas afficher d’erreur si en mode "silent"
    clearMessages(outer);
    if (!silent && isInvalid) {
        addMessage(outer, message);
    }

    return !isInvalid;
}

function checkFormValidity(inputs, button) {
    let isFormValid = true;

    inputs.forEach(input => {
        const outer = getFormOuter(input);
        const isTouched = outer.dataset.touched === 'true';

        // On valide le champ même s’il n’a pas été touché, mais sans afficher d’erreur
        const isValid = validateField(input, { silent: !isTouched });

        if (!isValid) isFormValid = false;
    });

    button.disabled = !isFormValid;

    return isFormValid;
}

function validateForm (id) {
    const form = document.getElementById(id);
    if (!form) return false;

    switch (id) {
        case 'form-landing-innovative-wood-stoves-designed-for-architecture':
        case 'form-newsletter':

            attachFormSubmitHandler(form);
            break;
    }
    
	// const inputs = form.querySelectorAll('.form-input');
    const inputs = Array.from(form.querySelectorAll('.form-input')).filter(el => {
    const outer = el.closest('.form-outer');
    const isButton = el.tagName === 'BUTTON';
    const isRequired = outer?.hasAttribute('data-empty');

        return !isButton && isRequired;
    });
    const button = form.querySelector('button[data-submit]');

	// Events
	inputs.forEach(input => {
        input.addEventListener('input', () => {
            validateField(input); // visuel immédiat si touché
            checkFormValidity(inputs, button);
        });
        input.addEventListener('blur', () => {
            getFormOuter(input).dataset.touched = 'true';
            validateField(input); // affichage message
            checkFormValidity(inputs, button);
        });
        if (input.tagName.toLowerCase() === 'select' || input.type === 'checkbox') {
            input.addEventListener('change', () => {
                getFormOuter(input).dataset.touched = 'true';
                validateField(input);
                checkFormValidity(inputs, button);
            });
        }
    });
}

function resetFormValidation(id) {
    const form = document.getElementById(id);
  const inputs = form.querySelectorAll('.form-input');
  inputs.forEach(input => {
    const outer = input.closest('.form-outer');
    outer.setAttribute('data-empty', true);
    outer.removeAttribute('data-invalid');
    outer.removeAttribute('data-touched');

    const messages = outer.querySelector('.form-messages');
    if (messages) messages.innerHTML = '';
  });

  const button = form.querySelector('button[data-submit]');
  if (button) button.disabled = true;

  form.reset();
}

function initModals() {
  const modals = document.querySelectorAll(".modal-outer");
  const launchers = document.querySelectorAll(".launcher-modal");

  // Déplace toutes les modals dans <body>
  modals.forEach(modal => {
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  });

  function closeAllModals() {
    modals.forEach(mod => {
      mod.classList.remove('active');

      // Reset validation si un form est présent
      const form = mod.querySelector('form');
      const intro = mod.querySelector('.ressources-intro-container')
      const thanks = mod.querySelector('.ressources-thanks-container')
      if (form) resetFormValidation(form.id);
        if (intro) intro.classList.remove('hidden');
        if (thanks) thanks.classList.add('hidden');
        
    });
    document.body.classList.remove('modal-open');
  }

  launchers.forEach(launcher => {
    launcher.addEventListener('click', () => {
      const targetId = launcher.dataset.target;
      const modal = Array.from(modals).find(modal => modal.id === targetId);

      if (modal) {
        closeAllModals();

        // Ouvre celle-ci
        modal.classList.add('active');
        document.body.classList.add('modal-open');

        const form = modal.querySelector('form');
        if (form) validateForm(form.id);
        attachFormSubmitHandler(form);
      }
    });
  });

  // Ajouter gestion fermeture au clic sur .close-modal
  document.querySelectorAll('.close-modal').forEach(btn => {
    btn.addEventListener('click', () => {
      closeAllModals();
    });
  });
}

function attachFormSubmitHandler(form) {
    // Empêche d'ajouter plusieurs fois le listener
    if (form.dataset.submitAttached === 'true') return;
    
    const inputs = Array.from(form.querySelectorAll('.form-input')).filter(el => {
        const outer = el.closest('.form-outer');
        const isButton = el.tagName === 'BUTTON';
        const isRequired = outer?.hasAttribute('data-empty');

        return !isButton && isRequired;
    });
    const button = form.querySelector('button[data-submit]');

  form.addEventListener('submit', (e) => {    
    e.preventDefault();

    // Revalider tous les champs
    const isValid = checkFormValidity(inputs, button)

    console.log(e);
    
    if (isValid) {
        const options = {
            eventCategory: 'landing', 
            eventAction: 'landing-uk',
            dataCategory: form?.dataset?.category ?? null
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'submit',
            ...options,
        });

        e.target.submit();
       
      // 🔥 Soumission valide : tu peux faire un fetch, ajax, etc.
    //   console.log(`Formulaire #${form.id} soumis avec succès.`);

      // Exemple : envoi simulé
      // fetch('/submit', { method: 'POST', body: new FormData(form) })

      // Fermer le modal ou afficher une confirmation
    //   form.closest('.modal-outer').classList.remove('active');
    //   document.body.classList.remove('modal-open');
    } else {
      console.log(`Formulaire #${form.id} invalide.`);
    }
  });

  form.dataset.submitAttached = 'true'; // évite les doublons
}